import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

import { DirectivesModule } from '@shared/directives/directives.module';
import { ButtonModule } from '@shared/components/button/button.module';
import {
  FormFieldCrudControlsModule
} from '@shared/components/formly-custom-templates/form-field-crud-controls/form-field-crud-controls.module';

import { CustomFieldInputComponent } from './custom-field-input.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    FormlyModule,
    DirectivesModule,
    FormFieldCrudControlsModule
  ],
  declarations: [CustomFieldInputComponent],
  exports: [CustomFieldInputComponent]
})
export class CustomFieldInputModule { }
